import { createContext } from 'react';

/**
 * Context for whether the main slot is sticky.
 */
export const MainStickyContext = createContext(false);
